export const googleConsentMode = (marketing: boolean, analysis: boolean, mode: string, hasConsentedBefore: boolean) => {
  const marketingStatus = marketing ? "granted" : "denied";
  const aString = analysis ? "granted" : "denied";

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function gtag(x: any, y: any, z: any) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }

  const consent = {
    ad_storage: marketingStatus, //Marketing switch
    analytics_storage: aString, //Statistical switch
    ad_user_data: marketingStatus,
    ad_personalization: marketingStatus,
  };

  if (consent.ad_storage === "denied" && hasConsentedBefore) {
    consent["ads_data_redaction"] = true;
  }
  gtag("consent", mode, consent);
};

/**
 * GoogleConsentMode must be run before this, else we don't get the analytics for this.
 *
 * @param marketing - Indicates whether marketing cookies are accepted.
 * @param analysis - Indicates whether analysis cookies are accepted.
 * @param personalization - Indicates whether personalization cookies are accepted.
 */
export const trackCookieConsentData = (marketing: boolean, analysis: boolean, personalization: boolean) => {
  let consentValue = "";

  if (marketing && analysis && personalization) {
    consentValue = "accept_all";
  } else if (!marketing && !analysis && !personalization) {
    consentValue = "accept_none";
  } else {
    consentValue = `accept_some_A${analysis ? 1 : 0}M${marketing ? 1 : 0}P${personalization ? 1 : 0}`;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "GAEvent",
    GA4EventName: "cookie_consent_response",
    GA4InputFieldName1: "consent_value",
    GA4InputFieldValue1: consentValue,
  });
};
